// Can't find where this is used, but I don't want to delete it yet

import { Injectable } from "@angular/core";

@Injectable()
export class ProficiencyReturn {
    constructor() {}

    // accepts a decimal, converts it to a percent, and returns a string
    getProficiency(score: number | null) {
        let proficiencyString;
        score = score ? score * 100 : 0; // prevent dividing by zero
        if (score) {
            if (score > 85) {
                proficiencyString = "proficient";
            } else if (score > 70) {
                proficiencyString = "near proficient";
            } else {
                proficiencyString = "needs remediation";
            }
        } else {
            proficiencyString = "not attempted";
        }
        return proficiencyString;
    }

    // accepts a string value of a proficiency, and returns a color that can serve as a CSS class
    colorReturn(status: string, isAvg: boolean) {
        let cssClass;
        switch (status) {
            case "needs remediation":
            case "remediation suggested":
                cssClass = "red";
                break;
            case "near proficient":
                cssClass = "yellow";
                break;
            case "proficient":
                cssClass = "green";
                break;
            case "not attempted":
                cssClass = "gray";
                break;
            default:
                cssClass = "na";
                break;
        }
        if (isAvg) {
            cssClass = cssClass + " classAverage";
        }
        return cssClass;
    }
}
